<div class="loader" *ngIf="isLoading$ | async">
  <div class="spinner"></div>
  <div class="network-info" [style.color]="networkColor">
    <svg *ngIf="showBars" class="network-icon" viewBox="0 0 24 24" fill="currentColor">
      <rect x="1" y="14" width="4" height="8" rx="1"/>
      <rect x="7" y="9"  width="4" height="13" rx="1"/>
      <rect x="13" y="4" width="4" height="18" rx="1"/>
      <rect x="19" y="1" width="4" height="21" rx="1"/>
    </svg>
    <span *ngIf="!showBars" class="offline-icon">✕</span>
    {{ networkText }}
  </div>
</div>